var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import { wrapWithComponent } from '../../utilities/wrapWithComponent';
import { CardSection } from './CardSection';
export const Card = (_a) => {
    var { active, base, children, className, dark, disabled, href, hoverable, el = 'div', elevation = 'flat', error, light, padding = 'default', placeholder, raised, thin, sharp, status } = _a, rest = __rest(_a, ["active", "base", "children", "className", "dark", "disabled", "href", "hoverable", "el", "elevation", "error", "light", "padding", "placeholder", "raised", "thin", "sharp", "status"]);
    const getElevation = () => {
        if (base)
            return 'base';
        if (raised)
            return 'raised';
        return elevation;
    };
    const getPadding = () => {
        if (thin)
            return 'thin';
        return padding;
    };
    const getStatus = () => {
        if (error)
            return 'error';
        if (active)
            return 'active';
        return status;
    };
    const CardClasses = classnames('Card', className, {
        'Card--base': getElevation() === 'base',
        'Card--raised': getElevation() === 'raised',
        'Card--thin': getPadding() === 'thin',
        'Card--no-padding': getPadding() === 'none',
        'Card--active': getStatus() === 'active',
        'Card--error': getStatus() === 'error',
        'Card--sharp': sharp,
        'Card--hoverable': hoverable || href || el === 'a' || rest.onClick,
        'Card--disabled': disabled,
        'Card--placeholder': placeholder,
        'Card--dark': dark,
        'Card--light': light,
    });
    const CardElement = href ? 'a' : el;
    return (React.createElement(CardElement, Object.assign({ className: CardClasses, href: href }, rest), wrapWithComponent(children, CardSection)));
};
Card.Section = CardSection;
//# sourceMappingURL=Card.js.map